import React, {   useState } from "react";
import { NavLink, Link,   useLocation } from "react-router-dom";
 import {  useSelector } from "react-redux";
 import 'react-bootstrap-typeahead/css/Typeahead.css';
 import {AiOutlineMenu} from "react-icons/ai"
import { MediaSidebarData } from './MediaSidebarData';
import MediaSidebarItem from './MediaSidebarItem';
import {RxCross2} from "react-icons/rx"
 import {FaUserCheck} from "react-icons/fa";
import {FaUser} from "react-icons/fa"

  import { MdEmail } from "react-icons/md";
 import Container from "./Container";
 import { FaFacebook } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa6";
import { FiMenu } from "react-icons/fi";


const Header = () => {
    const authState = useSelector(state => state?.auth)
  const location = useLocation();
   
  const showSideBar = () => {
    setSidebar(!sidebar);
    document.body.classList.toggle('sidebar-active', !sidebar);
  };
  
  const [sidebar, setSidebar] = useState(false);

 

  return (
    <>

<Container class1={` header-wrapper ${location.pathname !== "/" ? "header-wrapper-el " : ""}`}>

     <header className={`header-top-strip ${location.pathname !== "/" ? "header-top-strip-el":""}`}>
        <div className="container-xxl">
          <div className="row free-shipping">
            <div className="col-6 d-flex align-items-center text-white location-1">
            <MdEmail className="email-icon" />
              <p className="  text-white mb-0">
              Info@Qentrain.com
              </p>
            </div>
            <div className="col-6">
            <div className="social-icons justify-content-end d-flex align-items-center gap-30 ">
            <a className="text-white" href="#">
              <FaInstagram className=" social-icon" />
            </a>
            <a className="text-white" href="#">
              <FaXTwitter className=" social-icon" />
            </a>
            <a className="text-white" href="">
              <FaFacebook className=" social-icon" />
            </a>
          </div>
            </div>
          </div>

        </div>
      </header>
 
      <header className={` header-upper py-3 fixed-header ${location.pathname !== "/" ? "fixed-header-wrapper" : ""}`}>
        <div className=" container-xxl">
          <div className="row align-items-center">
            <div className="col-2 h-upper-links">
              <div className="electro-logo d-flex align-items-center">


   
              <div className={sidebar ? 'sidebar active' : 'sidebar'}>
  <div className='sidebar-header'>
    <h1> Qen<span>train</span></h1>
  
    <RxCross2 className='cross-btn'onClick={showSideBar}/>
    
  </div>
       {MediaSidebarData.map((item,index) =>  <MediaSidebarItem key={item.id} item={item} onClick={showSideBar}/>)}
      </div>
      {sidebar && <div className="overlay" onClick={showSideBar}></div>}

              <Link to="/" className="logo-img-container">
      
          <h1> Qen<span>train</span></h1>
              </Link>
              </div>
              <div className="col-5 h-upper-links2">
              <div className="header-upper-links2 gap-10  d-flex align-items-center ">
        

          <div className="menu-wrapper">
          <AiOutlineMenu className="menu-btn" onClick={showSideBar}/>

          </div>
  


               
         
              
              </div>
            </div>
            </div>
            <div className="col-5 menu-links-container">
            <div className="menu-links">
            <div className="d-flex align-items-center menu-links-nav">
            <NavLink
              className={({ isActive }) => (isActive ? "nav-link active-link" : "nav-link")}
              to="/"
            >
              Home
            </NavLink>
            <NavLink
              className={({ isActive }) => (isActive ? "nav-link active-link" : "nav-link")}
              to="/about"
            >
              About
            </NavLink>
            <NavLink
              className={({ isActive }) => (isActive ? "nav-link active-link" : "nav-link")}
              to="/courses"
            >
              Courses
            </NavLink>
            <NavLink
              className={({ isActive }) => (isActive ? "nav-link active-link" : "nav-link")}
              to="/events"
            >
              Events
            </NavLink>
            <NavLink
              className={({ isActive }) => (isActive ? "nav-link active-link" : "nav-link")}
              to="/contact"
            >
              Contact
            </NavLink>

            </div>
          </div>

            </div>
          
          </div>
        </div>
      </header>
     </Container>


    </>
  );
};

export default Header;